import type { PlayerBonus, PlayerFreespin } from 'api/common';
import { isReceivedBonus } from 'modules/bonuses/helpers/unseenBonuses';

export const findReceivedBonus = <T extends PlayerBonus | PlayerFreespin>(
  incomingBonuses: T[],
  previousBonuses: T[],
  isLoaded: boolean
) => {
  if (!isLoaded) return;

  const prevBonusesById = new Map(
    previousBonuses.map((bonus) => [bonus.id, bonus])
  );

  return incomingBonuses.find((bonus) =>
    isReceivedBonus(bonus, prevBonusesById.get(bonus.id))
  );
};
